'use strict';

const Alerts = require('lib/alerts');
const moment = require('moment');
const EmployerBaseRouter = require('./Base');
const CalendarView = require('commons/views/calendar/Calendar.js');
const loader = require('helpers/loader');
const LeaveRequestLayoutView = require('../views/LeaveLayout');
import Log from 'lib/log';
import LeaveRequest,
    {consts as LeaveRequestConsts} from 'newModels/leave-request.js';
import Employees from 'newCollections/employees.js';

const log = Log('commons/router/calendar');

module.exports = EmployerBaseRouter.extend({
    routes: {
        'calendar/date/:date': 'calendarDate',
        'calendar/add/:date': 'add',
        'calendar/add': 'add',
        'calendar/edit/:id': 'edit',
        'calendar/:id/:action': 'calendarAction',
        'calendar(/:locationId)': 'calendar',

        // Backwards compatibility
        'requestLeave/add': 'add',
        'requestLeave/add/:date': 'add',
        'requestLeave/edit/:id': 'edit'
    },

    titles: {
        'calendar': 'Calendar',
        'calendar/:date': 'Calendar',
        'calendar/:id/:action': 'Calendar',
        'calendar/add': 'Request Leave',
        'calendar/add/:date': 'Request Leave',
        'calendar/edit/:id': 'Request Leave',
        'requestLeave/add': 'Request Leave',
        'requestLeave/add/:date': 'Request Leave',
        'requestLeave/edit/:id': 'Request Leave'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {log: log});
        EmployerBaseRouter.prototype.initialize.apply(this, [this.options]);
    },

    calendarDate: function(date) {
        this.calendar({
            date: moment(date, 'DD-MM-YYYY')
        });
    },

    calendarAction: function(id, action) {
        this.calendar({
            id: id,
            action: action
        });
    },

    calendar: function(arg) {
        const options = typeof arg === 'string' ?
            {} : arg || {};
        const locationId = app.user.isEmployee() &&
            app.employee.companyLocation.id;

        const stopLoader = loader.startFullPage(this.el);

        this._fetchCalendarData(locationId)
            .then(({
                allEmployees, employees, userEmployee, locations,
                selectedLocation, holidays, isEmployer,
                collection, fetchMore, layerMap
            } = {}) => {
                new CalendarView({
                    allEmployees,
                    employees,
                    userEmployee,
                    locations,
                    selectedLocation,
                    holidays,
                    isEmployer,
                    collection,
                    fetchMore,
                    layerMap,
                    el: '#main-area'
                }).render(options);
            })
            .catch(err => {
                log.error(err);
                Alerts.show('criticalError', err);
            })
            .finally(() => stopLoader());
    },

    _fetchCalendarData: function() {
        return Promise.reject('You must override this fn');
    },

    _fetchLeaveData: function() {
        const employees = new Employees(null, {
            company: app.company,
            pagination: false
        });
        return employees.fetch({
            filter: {where: {hiddenAt: null}, limit: 9999},
            validate: false
        });
    },

    add: function(date) {
        this.layout = new LeaveRequestLayoutView({
            el: '#main-area',
            MainView: this.LeaveMainView
        });

        this._fetchLeaveData()
            .then(employees => {
                /* TODO: at the moment employees and types are expected
                 to be arrays. Make them collections. */
                const leaveRequest = new LeaveRequest({
                    dateFromType: LeaveRequestConsts.DATE_TYPE_FULL_DAY,
                    dateToType: LeaveRequestConsts.DATE_TYPE_FULL_DAY
                });
                const leaveDays = app.company.get('leaveDays');
                if (date) {
                    const m = moment(date, 'DD-MM-YYYY');
                    leaveRequest.set({
                        'dateFrom': new Date(
                            Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)
                        ),
                        'dateTo': new Date(
                            Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)
                        )
                    });
                }
                const leaveTypes = app.leaveTypes.filter(type => {
                    const isHidden = type.get('hiddenAt');
                    const leaveDaysOf = leaveDays[type.id] || 0;
                    const companyId = type.get('companyId');
                    const unpaid = !type.get('paid');
                    const allCustomLeaveDays = leaveDaysOf >= 0 && companyId;
                    const entitledDefaultLeaveDays = leaveDaysOf > 0;
                    return !isHidden && (
                        entitledDefaultLeaveDays ||
                        allCustomLeaveDays ||
                        unpaid
                    );
                });

                this.layout.renderContent({
                    employees,
                    leaveRequest,
                    leaveTypes,
                    attachments: null
                });
            })
            .catch(err => {
                log.error(err);
                Alerts.show('criticalError', err);
            })
            .finally(() => this.layout.hideLoader());
    },

    edit: function(id) {
        const employees = new Employees(null, {
            company: app.company,
            pagination: false
        });
        const leaveRequest = new LeaveRequest({objectId: id});

        this.layout = new LeaveRequestLayoutView({el: this.el});

        return Promise.all([
            leaveRequest.fetch(),
            employees.fetch({filter: {
                where: {hiddenAt: null},
                limit: 9999
            }, validate: false})
        ])
            .then(([leaveRequest]) => {
                this.layout.renderContent({
                    employees,
                    leaveRequest,
                    leaveTypes: app.leaveTypes.models,
                    attachments: []
                });
            })
            .catch(err => {
                log.error(err);
                Alerts.show('criticalError', err);
            })
            .finally(() => this.layout.hideLoader());
    }
});



// WEBPACK FOOTER //
// ./app/commons/routers/Calendar.js